<div class="grid-x grid-margin-x">
    <div class="cell small-12">Other Workflow Instance Id Rule:</div>
    <div class="cell small-12"><input type="text" [(ngModel)]="conf.otherWorkflowIdRule" /></div>

    <div class="cell small-12">Other Workflow Transition Name Rule:</div>
    <div class="cell small-12"><input type="text" [(ngModel)]="conf.otherWorkflowTransitionRule" /></div>

    <div class="cell small-12">Execution Condition Rule -- Other Workflow's Context:</div>
    <div class="cell small-12"><input type="text" [(ngModel)]="conf.otherWorkflowContextShouldInvokeRule" /></div>


</div>